import styled from 'styled-components';
import {
  spacer12,
  spacer20,
  spacer40,
  screenXsMax,
} from '@spotify-internal/encore-foundation';

export const Help = styled.div`
  position: fixed;
  bottom: ${spacer40};
  right: ${spacer20};

  /* less spacing for mobile */
  @media (max-width: ${screenXsMax}) {
    bottom: ${spacer12};
    right: ${spacer12};
  }
`;
